import "./services.css";
import Service from "./Service";
import Section from "../../../common/Section/Section";

// Icons for each service
import responsiveWebAppsIcon from "../../../../assets/img/icons/services/RWA.svg";
import databaseDevIcon from "../../../../assets/img/icons/services/DD.svg";
import microsoftOfficeAppsIcon from "../../../../assets/img/icons/services/MOA.svg";
import cloudAppsIcon from "../../../../assets/img/icons/services/CA.svg";
import technicalDirectionIcon from "../../../../assets/img/icons/services/TD.svg";
import projectMgmtIcon from "../../../../assets/img/icons/services/PM.svg";

// Thumbnail photos for each service.
import managementMeeting from "../../../../assets/img/other/ManagementMeeting2.webp"
import qrScanner from "../../../../assets/img/other/QRScanner.webp"
import manOnLaptop from "../../../../assets/img/other/ManOnLaptopWarehouse.webp"
import jobSiteEquipment from "../../../../assets/img/other/JobSiteEquipment.webp"
import boxesAndBarcode from "../../../../assets/img/other/BoxesAndBarcode.webp"
import windTurbineAndShip from "../../../../assets/img/other/WindTurbineAndShipSunset.webp"

/**
 * List of service objects that will be rendered on to the document.
 * */
const services = [
    {
        icon: databaseDevIcon,
        title: "Know what you have",
        subtitle: "Equipment and tools",
        description: "Keep equipment records together so your team can see what you have, where it is and its status.",
        hoverImage: managementMeeting
    },
    {
        icon: technicalDirectionIcon,
        title: "Stay ahead of maintenance",
        subtitle: "Maintenance and inspections",
        description: "Keep maintenance information in one place and use alerts to help your team plan ahead and reduce downtime.",
        hoverImage: manOnLaptop
    },
    {
        icon: responsiveWebAppsIcon,
        title: "See your stock clearly",
        subtitle: "Parts and stock",
        description: "Bring parts and stock records together so your team can check what's available and plan what they need.",
        hoverImage: boxesAndBarcode
    },
    {
        icon: cloudAppsIcon,
        title: "Spend less time chasing",
        subtitle: "One cloud-based system",
        description: "Give your team one place to find equipment, maintenance and stock information, with fewer scattered records and less admin.",
        hoverImage: windTurbineAndShip
    },
    {
        icon: microsoftOfficeAppsIcon,
        title: "Find information quickly",
        subtitle: "QR scanning",
        description: "Scan an equipment QR code with your phone to check its location and status without searching through paperwork.",
        hoverImage: qrScanner
    },
    {
        icon: projectMgmtIcon,
        title: "Keep jobs organised",
        subtitle: "Jobs and equipment allocation",
        description: "Allocate equipment to jobs and keep job records together, so your team can see what's assigned and move equipment between jobs with confidence.",
        hoverImage: jobSiteEquipment
    }
]

export default function Services() {
    return (
        <Section
            title="Less admin. More control."
            subtitle="Bring your equipment, maintenance, parts and stock together, and make everyday work easier."
            scrollID="services"
            className="text-center fs-5 py-6"
        >
            <div className="services-container limit-width">
                {
                    // Bind service to a Service component.
                    services.map(service => (
                        <Service service={service} key={service.title} />
                    ))
                }
            </div>
        </Section>
    )
}
